import { Header3 } from '@app/components/general/header'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { Wrapper } from '../article/wrapper'
import { ArticleHeader } from './header'
import { RenderSection, SectionProps } from './render-section'
import { CardGuides } from '../stateless/card/card-guides'
import { GrEmptyCircle } from 'react-icons/gr'

interface ArticleProps {
  translation: string
  index?: number
  parentRoute?: 'blog' | 'guides'
  featuredItems?: {
    href: string
    category: string
    date: Date
    index: number
    backgroundImage?: string
    alt?: string
  }[]
  category: string
}

// Generic Article component that takes in a locale for translations
export const Article = ({
  translation,
  index,
  featuredItems,
  parentRoute,
  category,
}: ArticleProps) => {
  const { t, lang } = useTranslation(translation)

  // index of item in general list of all items
  const idx = index ?? 0

  // the filtered features - remove first two items that are featured
  const featuredFilters = featuredItems?.filter(
    (item) => item.category === category && item.index !== idx
  )

  const blogDate = featuredItems ? featuredItems[idx].date : undefined

  const sections = t('sections', {}, { returnObjects: true })

  return (
    <Wrapper websiteUrl={'/guides'}>
      <div className='px-4 mx-auto container max-w-5xl space-y-8'>
        <ArticleHeader date={blogDate} t={t} category={undefined} />

        {sections && Array.isArray(sections)
          ? sections.map((item: SectionProps, index: number) => (
              <RenderSection
                item={item}
                index={index}
                key={`section-guide-${index}`}
                lang={lang}
              />
            ))
          : null}

        {featuredFilters ? (
          <>
            <div className='py-4'>
              <Header3 className='text-center'>{t('guides:related')}</Header3>
            </div>

            {featuredFilters?.length ? (
              <div className='grid grid-cols-1 md:grid-cols-3 gap-3 pb-12'>
                {featuredFilters.map(
                  ({ href, category, date, backgroundImage, index }) => {
                    return (
                      <CardGuides
                        key={`article-card-${index}`}
                        category={category}
                        href={href}
                        date={date}
                        cardTitle={`features.${index}.title`}
                        cardDescription={`features.${index}.details`}
                        backgroundImage={backgroundImage}
                        translation={parentRoute}
                        sm
                      />
                    )
                  }
                )}
              </div>
            ) : (
              <div className='flex place-items-center place-content-center pb-12'>
                <GrEmptyCircle className='grIcon text-xl' />
              </div>
            )}
          </>
        ) : null}
      </div>
    </Wrapper>
  )
}
